module.exports = __webpack_public_path__ + "img/custom_service_account.6c1ce41f.png";